module.exports = __webpack_public_path__ + "static/media/target.2dbb81c6.svg";